// extracted by mini-css-extract-plugin
module.exports = {"block":"input-module--block--2XVkm","input":"input-module--input--1jY-1","visual":"input-module--visual--3d1BH","label":"input-module--label--1hzJx"};